import apiCore from '../../utils/api-core';

// ── v3 paginated list endpoints ─────────────────────────────────────

export function getCompanies(params) {
    return apiCore.get('/api/v3/companies', { params });
}

export function getCompanyUsers(companyId, params) {
    return apiCore.get(`/api/v3/company/${companyId}/users`, { params });
}

export function getCompanyDepartmentsList(companyId, params) {
    return apiCore.get(`/api/v3/company/${companyId}/departments/list`, { params });
}

export function getCompanyDepartments(companyId) {
    return apiCore.get(`/api/v3/company/${companyId}/departments`);
}

export function getCompanyEmailGroups(companyId, params) {
    return apiCore.get(`/api/v3/company/${companyId}/email-groups`, { params });
}

// ── Company CRUD ─────────────────────────────────────────────────────

export function getAllCompanies(includeInactive = '') {
    const queryParam = includeInactive === '' ? '' : '?includeInactive=false';
    return apiCore.get('/api/v1/companies' + queryParam);
}

export function createCompany(data) {
    return apiCore.post('/api/v1/companies', data);
}

// ── Users (v3 company-scoped) ────────────────────────────────────────

export function createUser(companyId, data) {
    return apiCore.post(`/api/v3/company/${companyId}/users`, data);
}

export function updateUser(companyId, id, data) {
    return apiCore.put(`/api/v3/company/${companyId}/users/${id}`, data);
}

export function deleteUser(companyId, id) {
    return apiCore.delete(`/api/v3/company/${companyId}/users/${id}`);
}

// Assign a pool Vonage number (vonagenumbers.id) as the user's 1-1 texting
// number. GoHire-admin only; releases the current number server-side.
export function assignUserTextingNumber(companyId, id, vonagenumberId) {
    return apiCore.put(`/api/v3/company/${companyId}/users/${id}/texting-number`, { vonagenumberId });
}

// ── Departments (v3 company-scoped) ──────────────────────────────────

export function createDepartment(companyId, data) {
    return apiCore.post(`/api/v3/company/${companyId}/departments`, data);
}

export function getCompanyDepartment(companyId, id) {
    return apiCore.get(`/api/v3/company/${companyId}/departments/${id}`);
}

export function updateDepartment(companyId, id, data) {
    return apiCore.put(`/api/v3/company/${companyId}/departments/${id}`, data);
}

export function deleteDepartment(companyId, id) {
    return apiCore.delete(`/api/v3/company/${companyId}/departments/${id}`);
}

// ── Email Groups (v3 company-scoped) ─────────────────────────────────

export function createEmailGroup(companyId, data) {
    return apiCore.post(`/api/v3/company/${companyId}/email-groups`, data);
}

export function updateEmailGroup(companyId, id, data) {
    return apiCore.put(`/api/v3/company/${companyId}/email-groups/${id}`, data);
}

export function deleteEmailGroup(companyId, id) {
    return apiCore.delete(`/api/v3/company/${companyId}/email-groups/${id}`);
}

// ── System-email recipient overrides (v3, gohire-admin only) ─────────

export function getEmailRecipientRules(companyId) {
    return apiCore.get(`/api/v3/company/${companyId}/email-recipient-rules`);
}

export function upsertEmailRecipientRule(companyId, emailType, data) {
    return apiCore.put(`/api/v3/company/${companyId}/email-recipient-rules/${emailType}`, data);
}

export function deleteEmailRecipientRule(companyId, emailType) {
    return apiCore.delete(`/api/v3/company/${companyId}/email-recipient-rules/${emailType}`);
}

export function sendTestEmailRule(companyId, emailType, data) {
    return apiCore.post(`/api/v3/company/${companyId}/email-recipient-rules/${emailType}/test`, data);
}

// ── AI features per company (v3, gohire-admin only) — ADR-033 ────────

export function getCompanyAiFeatures(companyId) {
    return apiCore.get(`/api/v3/company/${companyId}/ai-features`);
}

export function updateCompanyAiFeature(companyId, featureKey, patch) {
    return apiCore.put(`/api/v3/company/${companyId}/ai-features/${featureKey}`, patch);
}

// ── Avatar ───────────────────────────────────────────────────────────

export function uploadUserAvatar(userId, formData) {
    return apiCore.post(`/api/v3/users/${userId}/avatar`, formData);
}

// ── Calendar / integrations ─────────────────────────────────────────

export function getUserSettings(userId) {
    return apiCore.get(`/api/v1/integrations/settings/${userId}`);
}

export function getCalendarPreview(userId, from) {
    return apiCore.get(`/api/v1/integrations/calendar-preview/${userId}/${encodeURIComponent(from)}`);
}
